import React from 'react'
import { HBox } from 'src/ui/layout'
import { HeroDesktopSecondary } from 'src/ui/organisms'
import { Body, Label } from 'src/ui/typography'
import { styled } from 'src/ui/theme'

const StyledLabel = styled(Label)`
  font-weight: 900;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0%;
  text-transform: uppercase;
`

const StyledLabelScore = styled(Label)`
  font-weight: 900;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0%;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.brand.primary};
`

const LabelContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`

export type Props = { images: TImages }

export const Score = ({ images }: Props) => {
  return (
    <HeroDesktopSecondary
      contentPosition="bottom-left"
      background={images['score']}
      title="Лучшие люди делают лучшую работу"
      titleSize="h2"
      titleAs="h2"
      height={724}
      label={
        <>
          <LabelContainer>
            <StyledLabel>индекс eNps</StyledLabel>
            <StyledLabelScore>4,6/5 баллов</StyledLabelScore>
          </LabelContainer>
          <HBox height={24} />
        </>
      }
    >
      <HBox height={24} />
      <Body
        style={{
          maxWidth: '520px',
        }}
      >
        В KODE люди важнее проектов, а процессы существуют, чтобы помогать
        людям.
      </Body>
      <HBox height={16} />
      <Body
        style={{
          maxWidth: '520px',
        }}
      >
        Эта ценность стала основой нашего HR-бренда.
      </Body>
    </HeroDesktopSecondary>
  )
}
